import { memo } from "react";
import Breadcrumb from "components/shared/breadcrumb";
import { Link, useParams } from "react-router-dom";
import UseFetch from "hooks/useFetch";
import { toMoneyFormat, unixToShamsi } from "utils";
import Loading from "components/shared/loading";

const View = () => {
    const { id } = useParams();
    const { isLoading, error, data, mutate } = UseFetch(`/api/financial/balance/withdraw/history/${id}`);

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">جزئیات تسویه حساب</h1>
                    <Breadcrumb data={[
                        { title: "تسویه حساب", link: '/panel/checkout' },
                        { title: "جزئیات تسویه حساب" }
                    ]} />
                </div>

                <div className="flex">
                    <Link to="/panel/checkout" className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>

                    <button className="w-10 h-10 tp-22 text-[#424e79] dark:text-white rounded-md fit-center" onClick={mutate} title="بروزرسانی">
                        <i className="fa-regular fa-arrows-retweet"></i>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="bg-yellow-100 flex items-center mb-5 rounded-md p-3 dark:bg-slate-800">
                                    <i className="fa-regular fa-circle-exclamation text-sm text-green-600 dark:text-green-300 ml-3"></i>

                                    <p className="text-sm text-green-800 dark:text-slate-300">
                                        <b className="inline-block ml-2">وضعیت</b>
                                        <span>
                                            {data.data.status_id === 0 && "در انتظار تایید"}
                                            {data.data.status_id === 1 && "تایید شده"}
                                            {data.data.status_id === 2 && "رد شده"}
                                        </span>
                                    </p>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>مبلغ</span>
                                            <b>{toMoneyFormat(data.data.amount)} تومان</b>
                                        </li>

                                        <li className="inline">
                                            <span>تاریخ ایجاد</span>
                                            <b>{unixToShamsi(data.data.created_at)}</b>
                                        </li>

                                        <li className="inline">
                                            <span>تاریخ بروزرسانی</span>
                                            <b>{unixToShamsi(data.data.update_at)}</b>
                                        </li>
                                    </ul>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>پیوست ها</span>
                                            <b>{data.data.attachments || "---"}</b>
                                        </li>

                                        <li className="inline">
                                            <span>شناسه تراکنش</span>
                                            <b>{data.data.transaction_id || "---"}</b>
                                        </li>

                                        <li className="inline">
                                            <span>کد پیگیری</span>
                                            <b>{data.data.tracking_code || "---"}</b>
                                        </li>

                                        <li className="inline">
                                            <span>تاریخ تسویه</span>
                                            <b>{data.data.withdrew_at ? unixToShamsi(data.data.withdrew_at) : "---"}</b>
                                        </li>
                                    </ul>
                                </div>

                                <div className="py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>توضیحات</span>
                                            <b>{data.data.description || "---"}</b>
                                        </li>
                                    </ul>
                                </div>
                            </>
                        ) : <p className="global-error">خطای سیستم !</p>
                    ) : (
                        <div className="flex justify-center">
                            <Loading className="loading-c5" />
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default memo(View);